import React from 'react'
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, XAxis } from 'recharts'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'

type Data = {
  income: number
  expense: number
}

const ForecastChart: React.FC<{ data: Data[]; title: string }> = ({ data, title }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="w-full bg-white shadow-md p-3">
      <div className="font-bold text-center text-lg">{title}</div>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="x" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="expense" fill="#00c8e1" name={t.controlling.forecast.expense} />
          <Bar dataKey="income" fill="#033147" name={t.controlling.forecast.income} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default ForecastChart
